export const buildUpgradeUrl = (opts) => {
    const currentPlanName = (opts.currentPlanName || '').toLowerCase();
    const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
    const url = currentPlanName && upgradePlanName
        ? `/app/billing/plans/upgrade/${currentPlanName}/${upgradePlanName}?interval=${opts.interval || 'month'}`
        : '/app/billing/plans';
    return encodeURI(url);
};
export const getShouldRenderSunsetCopy = (campaignOffers = []) => {
    const hasSunsetOffer = campaignOffers.length &&
        campaignOffers.every((offer) => !offer.acceptedAt &&
            offer.expiry &&
            new Date(offer.expiry) >= new Date());
    return hasSunsetOffer;
};
//# sourceMappingURL=utils.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
